<template>
  <Poptip
    :title="$t('info100')"
    trigger="hover"
    v-model="visible"
    class="show-columns-wrapper"
    placement="bottom-end"
  >
    <CloudIcon type="ios-more" />
    <div slot="content" class="show-columns-content">
      <LutticaScrollBar :height="headers.length > 10 ? '200px' : ''">
        <template v-for="(item, index) in headers">
          <p
            v-if="item.type !== 'index' && item.type !== 'selection'"
            class="columns-item"
            :key="index"
          >
            <Checkbox @on-change="val => handleShowChange(val, index)" :value="item.show">
              {{ item.title }}
            </Checkbox>
          </p>
        </template>
      </LutticaScrollBar>
    </div>
  </Poptip>
</template>

<script>
export default {
  name: 'ShowColumns',
  data() {
    return {
      visible: false,
      newHeaders: [],
    };
  },
  props: {
    headers: Array,
  },
  methods: {
    handleShowChange(val, index) {
      this.$emit('on-change-columns', val, index);
    },
  },
};
</script>

<style lang="less">
.show-columns-wrapper {
  position: absolute;
  top: 12px;
  right: 5px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: #fff;
  text-align: center;
  line-height: 30px;
  box-shadow: 0 0 3px 2px #ddd;
  z-index: 9;
  .ivu-icon {
    font-size: 28px;
    color: @primary-color;
  }
  .show-columns-content {
    overflow: auto;
    text-align: left;
    .columns-item {
      height: 20px;
      line-height: 20px;
      &:hover {
        color: @primary-color;
      }
    }
    .btn-wrapper {
      text-align: right;
      padding-top: 5px;
    }
  }
}
</style>
